<template>
    <v-app>
        <v-layout row wrap>
            <v-flex xs9 class="onboarding-container">
                <v-card>
                    <v-card-title class="primary white--text font-weight-bold">Board a new merchant</v-card-title>
                    <v-divider></v-divider>
                    
                    <v-form ref="form" lazy-validation>
                        <v-list>
                            <v-layout row wrap mt-3>
                                <v-flex xs6>
                                    <v-list-tile v-if="this.state == 'Live'">
                                        <v-select v-model="onBoard.platform" :items="platforms" dense label="Platform" class="pt-0 mt-0" required :rules="rules.required"></v-select>
                                    </v-list-tile>
                                    <v-list-tile v-if="this.state == 'Live'">
                                        <v-text-field v-model="onBoard.salesPerson" label="Sales Person" class="pt-0 mt-0" :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="this.state == 'Live'">
                                        <v-text-field v-model="onBoard.partnerSource" label="Partner Source" class="pt-0 mt-0" :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="this.state == 'Live'">
                                        <v-text-field v-model="onBoard.transactionFee" label="Transaction Fee" class="pt-0 mt-0" :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="this.state == 'Live'">
                                        <v-text-field v-model="onBoard.serviceFee" label="Service Fee" class="pt-0 mt-0" :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="this.state == 'Live'">
                                        <v-text-field v-model="onBoard.monthlyMinimum" label="Monthly Minimum" class="pt-0 mt-0" :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="this.state == 'Live'">
                                        <v-select v-model="onBoard.vat" label="VAT" :items="vatOptions" class="pt-0 mt-0" dense append-icon="search" :rules="rules.required"></v-select>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-combobox v-model="onBoard.division" :disabled="!divisions" :items="divisions" item-text="name" item-value="id" item-key="id" small-chips label="Division Name or UUID" class="pt-0 mt-0" @change="getMerchants($event, 'division')" clearable @click:clear="clearDivision" required :rules="rules.characters"></v-combobox>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-combobox v-model="onBoard.merchant" :disabled="!onBoard.division" :items="merchants" item-text="name" item-value="id" item-key="id" small-chips label="Merchant Name or UUID" class="pt-0 mt-0" clearable @click:clear="clearMerchant" required :rules="rules.characters"></v-combobox>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-text-field :disabled="!onBoard.division || !onBoard.merchant" v-model="onBoard.channel" label="Channel Name" class="pt-0 mt-0" required :rules="rules.characters"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile><v-select v-model="onBoard.transactionCategory" :items="transactionCategory" label="Transaction Category" required :rules="rules.required"></v-select></v-list-tile>
                                    <v-list-tile><v-select v-model="onBoard.merchantCategory" :items="merchantCategory" label="Merchant Category" required :rules="rules.required"></v-select></v-list-tile>
                                    <v-list-tile v-if="clearingInstitute != 'Concardis Test' && clearingInstitute != 'Concardis' && clearingInstitute != 'Wirecard Test' && clearingInstitute != 'Wirecard'">
                                        <v-text-field v-model="onBoard.merchantId" label="Merchant ID" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'Wirecard Test' || clearingInstitute == 'Wirecard'">
                                        <v-text-field v-model="onBoard.merchantId" label="Merchant ID" class="pt-0 mt-0"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'Concardis Test' || clearingInstitute == 'Concardis'">
                                        <v-text-field v-model="onBoard.merchantIdMc" label="Merchant ID (Mastercard)" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'Concardis Test' || clearingInstitute == 'Concardis'">
                                        <v-text-field v-model="onBoard.merchantIdVi" label="Merchant ID (Visa)" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'Wirecard Test' || clearingInstitute == 'Wirecard'">
                                        <v-text-field v-model="onBoard.bcSig" label="BC Signature" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                     <v-list-tile v-if="clearingInstitute == 'Optimalpayment Test' || clearingInstitute == 'Optimalpayment'">
                                        <v-text-field v-model="onBoard.storeId" label="Store ID" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'Optimalpayment Test' || clearingInstitute == 'Optimalpayment' || clearingInstitute == 'VCG Test' || clearingInstitute == 'Voice Commerce Group'">
                                        <v-text-field v-model="onBoard.password" label="Password" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute != 'Wirecard Test' && clearingInstitute != 'Wirecard' && clearingInstitute != 'Optimalpayment Test' && clearingInstitute != 'Optimalpayment' && clearingInstitute != 'VCG Test' && clearingInstitute != 'Voice Commerce Group'">
                                        <v-text-field v-if="state == 'Live'" v-model="onBoard.terminalId" label="Terminal ID" class="pt-0 mt-0" required :rules="rules.required" append-icon="mdi-plus-circle-outline" @click:append="getTerminalId" :loading="terminalLoading"></v-text-field>
                                        <v-text-field v-else v-model="onBoard.terminalId" label="Terminal ID" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'SecureTrading Omnipay Demo' || clearingInstitute == 'Securetrading_Omnipay'">
                                        <v-text-field v-model="onBoard.categoryCode" label="Merchant Category Code" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'SecureTrading Omnipay Demo' || clearingInstitute == 'Securetrading_Omnipay'">
                                        <v-text-field v-model="onBoard.acqInstCode" label="Acquiring Institution Code" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile><v-text-field v-model="onBoard.url" label="URL" class="pt-0 mt-0" required :rules="rules.required"></v-text-field></v-list-tile>
                                </v-flex>

                                <v-flex xs6>
                                    <v-list-tile v-if="clearingInstitute == 'Wirecard Test' || clearingInstitute == 'Wirecard'">
                                        <v-text-field v-model="onBoard.username" label="Username" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'Wirecard Test' || clearingInstitute == 'Wirecard'">
                                        <v-text-field v-model="onBoard.password" label="Password" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'SecureTrading Omnipay Demo' || clearingInstitute == 'Securetrading_Omnipay'">
                                        <v-text-field v-model="onBoard.creditSenderAddress" label="Street | City | Region | PostalCode | Two Digit Country Code" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'SecureTrading Omnipay Demo' || clearingInstitute == 'Securetrading_Omnipay'">
                                        <v-text-field v-model="onBoard.cardAcceptor" label="Two Digit Country Code | Three Digit Country Code | Street" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'SecureTrading Omnipay Demo' || clearingInstitute == 'Securetrading_Omnipay'">
                                        <v-text-field v-model="onBoard.descriptorFirst" label="Descriptor - First Line" class="pt-0 mt-0" required :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'SecureTrading Omnipay Demo' || clearingInstitute == 'Securetrading_Omnipay'">
                                        <v-text-field v-model="onBoard.descriptorSecond" label="Descriptor - Second Line" class="pt-0 mt-0"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile v-if="clearingInstitute == 'Bambora (via Evry)'">
                                        <v-text-field v-model="onBoard.merchantType" label="Merchant Type / MCC Code" class="pt-0 mt-0" :rules="rules.required"></v-text-field>
                                    </v-list-tile>
                                    <v-list-tile><v-select v-model="onBoard.schemes" label="Payment Schemes" :items="schemes" class="pt-0 mt-0" multiple small-chips dense append-icon="search" :rules="rules.multiple" required></v-select></v-list-tile>
                                    <v-list-tile><v-select v-model="onBoard.currencies" label="Currencies" :items="currencies" class="pt-0 mt-0" multiple small-chips dense append-icon="search" :rules="rules.multiple" required></v-select></v-list-tile>
                                    <v-list-tile><v-text-field v-model="onBoard.email" label="Email" class="pt-0 mt-0" :rules="rules.email"></v-text-field></v-list-tile>
                                    <v-list-tile><v-text-field v-model="onBoard.firstName" label="First Name" class="pt-0 mt-0"></v-text-field></v-list-tile>
                                    <v-list-tile><v-text-field v-model="onBoard.surname" label="Surname" class="pt-0 mt-0"></v-text-field></v-list-tile>
                                    <v-list-tile>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <v-checkbox v-model="onBoard.recType" multiple label="Non-Recurring" value="nonrec" @change="checkboxRecType"></v-checkbox>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-checkbox v-model="onBoard.recType" multiple label="Recurring" value="rec" @change="checkboxRecType"></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <v-checkbox v-model="onBoard.threeD" multiple label="Non-3D Channel" value="non3d" @change="checkboxThreeD"></v-checkbox>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-checkbox v-model="onBoard.threeD" multiple label="3D Channel" value="3d" @change="checkboxThreeD"></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <v-checkbox v-model="onBoard.threeD" multiple label="ApplePay" value="apple" @change="checkboxThreeD"></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </v-list-tile>
                                </v-flex>
                            </v-layout>
                        </v-list>
                    </v-form>
                    <v-divider></v-divider>
                    <v-card-actions>
                        
                        <v-spacer></v-spacer>
                        <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
                        <v-btn v-if="!loading" @click="onReset" color="error">Reset</v-btn>
                        <v-btn v-if="!loading" color="primary" @click="board">Ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex xs4>
                <!-- {{ this.onBoard }} -->
            </v-flex>
            <v-layout>
                <v-flex xs12>
                    <v-snackbar v-model="snackbar">
                        No Terminal ID's available.
                        <v-btn flat dark text @click="snackbar = false">Close</v-btn>
                    </v-snackbar>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-app>
</template>

<script>
    import sweetAlert from '../sweetAlert.js';
    import axios from 'axios';

    export default {
        data() {
            return {
                form: false,
                rules: { required: [ v => !!v || v == 0 || 'Required' ],
                         multiple: [ v => v.length == 0 ? 'Required' : false ],
                         email: [ v => this.emailRule(v) ],
                         characters: [ v => this.characterRule(v) ]
                        },
                onBoard: { terminalId: '' },
                vatOptions: [{ value: 0, text: '0%'},
                             { value: 20, text: '20%'}],
                schemes: [{ value: 'MASTER', text: 'Mastercard'},
                          { value: 'VISA', text: 'Visa'}],
                currencies: [{ value: 'AUD', text: 'AUD' },
                             { value: 'CAD', text: 'CAD' },
                             { value: 'COP', text: 'COP' },
                             { value: 'CHF', text: 'CHF' },
                             { value: 'CZK', text: 'CZK' },
                             { value: 'DKK', text: 'DKK' },
                             { value: 'GBP', text: 'GBP' },
                             { value: 'EUR', text: 'EUR' },
                             { value: 'HUF', text: 'HUF' },
                             { value: 'JPY', text: 'JPY' },
                             { value: 'KRW', text: 'KRW' },
                             { value: 'MYR', text: 'MYR' },
                             { value: 'MXN', text: 'MXN' },
                             { value: 'NOK', text: 'NOK' },
                             { value: 'NZD', text: 'NZD' },
                             { value: 'PLN', text: 'PLN' },
                             { value: 'NZD', text: 'NZD' },
                             { value: 'RON', text: 'RON' },
                             { value: 'RUB', text: 'RUB' },
                             { value: 'SEK', text: 'SEK' },
                             { value: 'SGD', text: 'SGD' },
                             { value: 'THB', text: 'THB' },
                             { value: 'TRY', text: 'TRY' },
                             { value: 'TWD', text: 'TWD' },
                             { value: 'USD', text: 'USD' },
                             { value: 'ZAR', text: 'ZAR' }],
                transactionCategory: [{ value: 'ANY', text: 'ANY' },
                                      { value: 'ECOMMERCE', text: 'ECOMMERCE' },
                                      { value: 'MOTO', text: 'MOTO'}],
                merchantCategory: [{ value: 'RETAIL', text: 'RETAIL' },
                                   { value: 'SERVICES', text: 'SERVICES' },
                                   { value: 'AIRLINE', text: 'AIRLINE'},
                                   { value: 'HOTEL', text: 'HOTEL'},
                                   { value: 'TRAVEL', text: 'TRAVEL'},
                                   { value: 'GAMING', text: 'GAMING'},
                                   { value: 'GAMBLING', text: 'GAMBLING'},
                                   { value: 'DIGITAL_CONTENT', text: 'DIGITAL_CONTENT'},
                                   { value: 'AUCTION', text: 'AUCTION'},
                                   { value: 'ADULT', text: 'ADULT'},
                                   { value: 'UTILITIES', text: 'UTILITES'},
                                   { value: 'E_TICKETING', text: 'E_TICKETING'},
                                   { value: 'ONLINE_FINANCIAL', text: 'ONLINE_FINANCIAL'}],
                divisions: null,
                merchants: null,
                loading: false,
                terminalLoading: false,
                terminalId: null,
                snackbar: false,
                platforms: [{ value: 'Bespoke', text: 'Bespoke' },
                           { value: 'Magento', text: 'Magento' },
                           { value: 'Shopify', text: 'Shopify' },
                           { value: 'Woocommerce', text: 'Woocommerce' }]
            }
        },
        mixins: [ sweetAlert ],
        props: {
            clearingInstitute: String,
            state: String
        },
        beforeMount() {
            this.listDivisions();

            if(this.clearingInstitute == 'Concardis Test') {
                this.onBoard.terminalId = '71F00013';
                this.onBoard.merchantIdMc = '157777776';
                this.onBoard.merchantIdVi = '147777776';
                this.onBoard.schemes = [ "MASTER", "VISA" ];
            }
        },
        methods: {
            listDivisions() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/list-divisions',
                data: { state: this.state },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.divisions = response.data.divisions.filter(division => division.state == 'LIVE')
                                                            .sort((a, b) => a.name.localeCompare(b.name));
                    
                    if(this.onBoard.division && this.onBoard.division !== Object(this.onBoard.division)) {
                        this.onBoard.division = response.data.divisions.find(division => division.name == this.onBoard.division);
                        this.listMerchants();
                    }
                    else if (this.onBoard.division) {
                        this.listMerchants();
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            listMerchants() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/list-merchants',
                data: { state: this.state, divisionId: this.onBoard.division.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data.merchants.filter(merchant => merchant.state == 'LIVE')
                                                            .sort((a, b) => a.name.localeCompare(b.name));

                    if(this.onBoard.merchant && this.onBoard.merchant !== Object(this.onBoard.merchant)) {
                        this.onBoard.merchant = response.data.merchants.find(merchant => merchant.name == this.onBoard.merchant);
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getMerchants(res, type) {
                if(type == 'division' && res === Object(res)) {
                    this.listMerchants();
                }
                else {
                    this.merchants = [];
                }
            },
            clearDivision() {
                this.onBoard.merchant = null;
                this.merchants = [];
                this.onBoard.channel = null;
            },
            clearMerchant() {
                this.onBoard.channel = null;
            },
            checkboxRecType() {
                if(this.onBoard.recType && this.onBoard.recType.length == 0) this.onBoard.recType = null;
            },
            checkboxThreeD() {
                if(this.onBoard.threeD && this.onBoard.threeD.length == 0) this.onBoard.threeD = null;
            },
            onReset(e) {
                this.$refs.form.reset();
            },
            emailRule(v) {
                let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if(typeof v !== 'undefined' && v)
                {   if(!pattern.test(v)) {
                        return 'Invalid Email address';
                    }
                    else { 
                        return true;
                    }
                } 
                else {
                    return true;
                }
            },
            characterRule(v) {
                let pattern = /^[A-Za-z0-9 -]*$/;
                
                if(v !== Object(v)) {
                    if(v) {
                        if(!pattern.test(v)) { 
                            return 'Invalid characters';
                        } else { 
                            return true; 
                        }
                    } else {
                        return 'Required';
                    }
                } else {
                    return true;
                }
            },
            getTerminalId() {

                this.terminalLoading = true;
                let clearingInstitute = this.clearingInstitute == 'BSCardServices' ? 'BS Payone' : this.clearingInstitute;

                axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/get-terminal-id',
                    data: { clearingInstitute: clearingInstitute },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        if(response.data.length) {
                            this.terminalId = '';
                            response.data.filter((row, i) => {
                                if(this.clearingInstitute == 'Concardis') {
                                    this.terminalId += response.data.length != i+1 ? row.terminalId+',' : row.terminalId;
                                }
                                else {
                                    this.terminalId = row.terminalId;
                                }
                            });
                        }
                        else if(!response.data.length && this.clearingInstitute == 'Securetrading_Omnipay') {
                            this.terminalId = 'PAYON001';
                        }
                        else {
                            this.snackbar = true;
                            this.terminalId = null;
                        }
                        
                        this.onBoard.terminalId = this.terminalId;
                        this.terminalLoading = false;
                    })
                    .catch(e => {
                        this.errors.push(e)
                    })
            },
            board() {
                if(this.$refs.form.validate()) {
                    this.loading = true;
                    axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/onboard',
                    data: { state: this.state, clearingInstitute: this.clearingInstitute, onBoard: this.onBoard, terminalId: this.terminalId },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.loading = false;
                        let result = null;

                        if(response.data === Object(response.data)) {
                            result = {};
                            for(let key in response.data) {
                                if(response.data.hasOwnProperty(key)) {
                                    result[key] = JSON.parse(response.data[key])
                                    this.sweetAlert(result);
                                }
                            }
                        }
                        else if(typeof response === 'string') {
                            result = response.data;
                            this.sweetAlert(result);
                        }
                        console.log(response);
                        this.listDivisions();
                    })
                    .catch(e => {
                        this.loading = false;
                        this.errors.push(e)
                    })
                }
            }
        }
    }
</script>

<style>
    .onboarding-container .v-list__tile__content {
        font-size: 12px;
    }

    .onboarding-container .v-divider {
        margin-top: 0;
    }

    .onboarding-container .v-list > .layout > .flex > div {
        padding: 10px 0px;
    }
</style>
